import { render, staticRenderFns } from "./CriarFaq.vue?vue&type=template&id=33e8d0b8&scoped=true&"
import script from "./CriarFaq.vue?vue&type=script&lang=js&"
export * from "./CriarFaq.vue?vue&type=script&lang=js&"
import style0 from "./CriarFaq.vue?vue&type=style&index=0&id=33e8d0b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e8d0b8",
  null
  
)

export default component.exports